import { render, staticRenderFns } from "./userMonitor.vue?vue&type=template&id=0badb268"
import script from "./userMonitor.vue?vue&type=script&lang=js"
export * from "./userMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports